export const errorTypes = {
  REACT_ERROR_BOUNDARY: 'REACT_ERROR_BOUNDARY'
};
